import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorPage } from '@guildeducationinc/recess';
import { useLocale } from 'pe-core-frontend';
import { useNavigate, useRouteError } from 'react-router-dom';
import styles from './Error.module.scss';
export const Error = () => {
    const { t } = useLocale();
    const navigate = useNavigate();
    const error = useRouteError();
    const msg = error?.status === 404 ? t('Page not found.') : '';
    return (_jsx(ErrorPage, { className: styles.container, goBack: () => navigate(-1), title: msg, message: ' ' }));
};
